type TProps = {
  error?: string | null;
  label: string;
  placeHolder?: string | null;
  value?: string | null;
  onClick: () => void;
  extraClasses?: string;
};

const FakeAddonInput = ({ label, placeHolder, value, onClick, error, extraClasses = '' }: TProps) => {
  return (
    <>
      <div
        role="button"
        className={`form-select fo-fake-addon-input ${extraClasses} ${error ? 'is-invalid' : ''}`}
        onClick={onClick}
      >
        <div className="caption -medium color-grey-500">{label}</div>
        {!value && <div className="text-1 -regular color-grey-500">{placeHolder}</div>}
        {value && <div className="text-1 -regular">{value}</div>}
      </div>
      {!!error && <div className="text-2 -regular color-error-600 mt-1">{error}</div>}
    </>
  );
};
export default FakeAddonInput;
